module.exports = __webpack_public_path__ + "static/media/ruby.5bbbbb44.png";